import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { GalleriaModule } from 'primeng/galleria';
import { DialogModule } from 'primeng/dialog'; // For Dialog Component
import { ButtonModule } from 'primeng/button';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Renderer2,
  viewChild,
  ViewChild,
} from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import * as bootstrap from 'bootstrap';
import { search_filter } from '../../../_model/search_fliter';
import { AuthenticationService } from '../../_services/authentication.service';
import { BusyService } from '../../_services/busy.service';
import { ConstantService } from '../../_services/constant.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { GlobalService } from '../../_services/global.service';
import { user_privilege } from '../../../_model/user_privilege';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CommanService } from '../../_services/comman.service';
import { PaginatorModule } from 'primeng/paginator';
import { DynamicSearchComponent } from '../../components/dynamic-search/dynamic-search.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

declare var $: any;
@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgFor,
    NgIf,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    GalleriaModule,
    ToastModule,
    PaginatorModule,
    SidebarComponent,
    NgClass
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent implements AfterViewInit {
  totalpages: any = 0;
  heading: string = '';
  toggle_sidebar: boolean = false;
  loadingCompleted: boolean = false;
  selectedPage: number = 1;
  currRow: any = 1;
  currPage: any = 15;
  // search_filters!: search_filter;
  search_filters!: any;
  isShowRaiseQuery: boolean = false;
  user_data: any;
  forms_initialized = false;
  isSignedIn = false;
  accountType: string = '';
  searchQueryGrid: string[] = [];
  fullImageUrl: string | null = null;
  initializedForm: boolean = false;
  form_RaiseQuery: FormGroup = new FormGroup({});
  totalRecords!: number;
  oldRecords!: number;
  dataAvailable: boolean = false; // Add this property
  data: any = {};
  listener: (() => void) | undefined;
  allData: any = {}; // Initialize as an object, not an array
  displayBasic: boolean = false; // To control visibility of the gallery dialog
  images: any[] = [];
  userid: string[] = [];
  gbrnArray: string[] = [];
  activeIngredientArray: any[] = [];
  currActiveIngredient: string = '';
  cols: any[] = []; // Declare gbrnArray property as an array of strings
  INCHIKEY: string = '';
  inchiKeyArray: string[] = [];
  columns: string[] = [];
  currentFilterCondition: any = [];
  fileToUpload: File | null = null; // Declare the fileToUpload property
  // privilege_json!: user_privilege;
  privilege_json!: any;
  application_query: string = '';
  private allowCopy = false;
  noResultsFound: boolean = false; // Start as false
  products: any[] = [];
  maxLines: number = 4;
  readMoreText: string = 'Read More';
  readLessText: string = 'Read Less';
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      circular: true,
      itemMargin: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      circular: true,
      itemMargin: 5,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      circular: true,
      itemMargin: 5,
    },
  ];
  currGBRN: any = 0;
  userPageLimit: any = 0;
  alertExecuted: boolean = false;
  // currPage:any = 0
  // currRow:any = 0
  constructor(
    private router: Router,
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private el: ElementRef,
    private messageService: MessageService,
    private commanService: CommanService
  ) {
    this.commanService.currentRow.subscribe((res) => {
      this.currRow = res;
    });
    this.commanService.currentPage.subscribe((res) => {
      this.currPage = res;
    });
    const navigation = this.router.getCurrentNavigation();
    // const state = navigation?.extras.state as {
    //   data: any;
    //   allData: any;
    //   userid: string[];
    //   gbrnArray: string[];
    //   inchiKeyArray: string[];
    //   privilege_json: user_privilege;
    //   currentFilterCondition: any;
    //   application_query: string; // Added the application_query
    //   search_filters: search_filter; // Added the search_filters
    //   cols: any[];
    //   columns: any[];
    //   totalRecords: any;
    //   oldRecords: any;
    //   searchQueryGrid: string[]; // Updated totalRecords to match the correct type
    // };

    let state = {
      data: {},
      allData: {},
      userid: [],
      gbrnArray: [],
      inchiKeyArray: [],
      activeIngredientArray: [], // added
      privilege_json: {},
      currentFilterCondition: '',
      application_query: '',
      search_filters: {},
      cols: [],
      columns: [],
      totalRecords: 0,
      oldRecords: 0,
      searchQueryGrid: [],
      currGBRN: 0,
      currActiveIngredient: '', // added
    };

    this.commanService.currentData.subscribe((res: any) => {
      state = res;

      this.data = state?.data || {};
      console.log("data : ", this.data);
      
      this.allData = state?.allData;
      this.userid = state?.userid || [];
      this.gbrnArray = state?.gbrnArray || [];
      this.inchiKeyArray = state?.inchiKeyArray || [];
      this.activeIngredientArray = state?.activeIngredientArray || []; // added
      this.privilege_json = state?.privilege_json || {};
      this.currentFilterCondition = state?.currentFilterCondition || [];
      this.application_query = state?.application_query || '';
      this.search_filters = state?.search_filters || {};
      this.cols = state?.cols || [];
      this.columns = state?.columns || [];
      this.totalRecords = state?.totalRecords || 0;
      this.oldRecords = state?.oldRecords;
      this.searchQueryGrid = state?.searchQueryGrid || null;
      this.currGBRN = res?.gbrn || 0;
      this.currActiveIngredient = res?.activeIngredient || ''; // added

      window.scrollTo(0, 0);
    });

    this.totalpages = Math.ceil(this.totalRecords / this.rows);
    this.commanService.currentPrivilege.subscribe((res: any) => {
      this.privilege_json = res ? (res.privilege_json || res) : {};
    });
  }
  @HostListener('document:copy', ['$event'])
  disableCopy(event: ClipboardEvent): void {
    if (!this.allowCopy) {
      event.preventDefault();
      alert('Copying is disabled on this page.');
    }
  }

  // Disable right-click context menu
  @HostListener('document:contextmenu', ['$event'])
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  // showModalIfNoRecords() {
  //   setTimeout(() => {
  //     const modalElement = document.getElementById('noRecordsModal');
  //     if (modalElement) {
  //       const noRecordsModal = new bootstrap.Modal(modalElement);
  //       noRecordsModal.show(); // Display the modal
  //     } else {
  //       console.error('Modal element with ID "noRecordsModal" not found.');
  //     }
  //   }, 0); // Slight delay to ensure the DOM is ready
  // }
  ngOnInit(): void {
    setTimeout(() => {
      this.globalService.sendMenuIndex(0); // 0=Search, 1=SPC Updates, 2=Support
    }, 0);

    this.getcolumnsdiscovery();

    this.form_RaiseQuery = this.fb.group({
      txtResponseEmail: [''],
      txtQuery: [''],
    });
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { allData: any };
    this.listener = this.renderer.listen(
      'document',
      'keydown',
      (event: KeyboardEvent) => {
        if (
          (event.ctrlKey || event.metaKey) &&
          event.key.toLowerCase() === 'p'
        ) {
          event.preventDefault();
        }
      }
    );

    // Use the full data if passed
    if (this.allData) {
      this.data = this.allData; // Restore full data
      this.totalRecords = this.oldRecords;
      console.log("333333333333333333",this.data)
    }

    // For Pagination

    // this.commanService.currentPage.subscribe((res:any)=>{
    //   this.currPage = res;
    // })
    // this.commanService.currentRow.subscribe((res:any)=>{
    //   this.currRow = res;
    //   console.log("super check rrrrrrrrrrrrrrr",this.currRow)
    // })

    this.commanService.userPageLimit.subscribe((res) => {
      this.userPageLimit = res;
      console.log("page limit : ",this.userPageLimit);
      
    });

    this.commanService.showPageLimitWarning.subscribe((res) => {
      // debugger;
      if (res) {
        if (!this.alertExecuted) {
          this.messageService.add({
            severity: 'error',
            summary: 'Page Limit Exceeded',
            detail: `You can only see ${this.userPageLimit} pages.`,
            life: 2000,
          });
          this.alertExecuted = true;
        }

        // this.commanService.showPageLimitWarning.next(false);
      } else {
        this.alertExecuted = false;
      }
    });

    if (sessionStorage.getItem('isRefreshed')) {
      sessionStorage.removeItem('isRefreshed'); // Clear the flag
      this.goBackToSearch(); // Redirect to the main page
    }

    // Listen to the beforeunload event
    window.addEventListener('beforeunload', this.handleRefresh);
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
      if (this.user_data.userid) {
        this.getUserAccountType(this.user_data.userid);
      }
    });
    console.log("+++++++++++++++++++++++++++++++++++++++++++++++column discovery called()");

  }
  ngOnDestroy() {
    // Clean up the event listener
    window.removeEventListener('beforeunload', this.handleRefresh);
  }
  handleRefresh() {
    sessionStorage.setItem('isRefreshed', 'true');
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const spans = this.el.nativeElement.querySelectorAll('.value');

      spans.forEach((span: HTMLElement) => {
        const fullText = span.innerText || '';

        // Get line height and calculate maximum height allowed for the given number of lines
        const lineHeight = parseInt(
          window.getComputedStyle(span).lineHeight,
          10
        );
        const maxHeight = lineHeight * this.maxLines;

        if (span.scrollHeight > maxHeight) {
          const truncatedText = this.truncateText(span, maxHeight);

          // Create a wrapper for the text and buttons
          const wrapper = this.renderer.createElement('div');
          this.renderer.addClass(wrapper, 'value-wrapper');
          this.renderer.setStyle(wrapper, 'display', 'inline');

          const textNode = this.renderer.createText(truncatedText);
          this.renderer.appendChild(wrapper, textNode);

          const readMoreButton = this.renderer.createElement('button');
          this.renderer.addClass(readMoreButton, 'read-more-btn');
          this.renderer.setProperty(
            readMoreButton,
            'textContent',
            this.readMoreText
          );

          const viewLessButton = this.renderer.createElement('button');
          this.renderer.addClass(viewLessButton, 'read-more-btn');
          this.renderer.addClass(viewLessButton, 'view-less-btn');
          this.renderer.setProperty(
            viewLessButton,
            'textContent',
            this.readLessText
          );
          this.renderer.setStyle(viewLessButton, 'display', 'none');

          this.renderer.appendChild(wrapper, readMoreButton);
          this.renderer.appendChild(wrapper, viewLessButton);

          this.renderer.setProperty(span, 'innerHTML', '');
          this.renderer.appendChild(span, wrapper);

          this.renderer.listen(readMoreButton, 'click', () => {
            this.renderer.setProperty(
              span,
              'innerHTML',
              this.transformNewLines(fullText)
            );
            this.renderer.appendChild(span, readMoreButton);
            this.renderer.appendChild(span, viewLessButton);
            this.renderer.setStyle(readMoreButton, 'display', 'none');
            this.renderer.setStyle(viewLessButton, 'display', 'inline-block');
          });

          this.renderer.listen(viewLessButton, 'click', () => {
            this.renderer.setProperty(
              span,
              'innerHTML',
              this.transformNewLines(truncatedText)
            );
            this.renderer.appendChild(span, readMoreButton);
            this.renderer.appendChild(span, viewLessButton);
            this.renderer.setStyle(viewLessButton, 'display', 'none');
            this.renderer.setStyle(readMoreButton, 'display', 'inline-block');
          });
        }
      });
    }, 0);
  }

  // Method to truncate the text based on the maximum allowed height
  truncateText(p: HTMLElement, maxHeight: number): string {
    let originalText = p.innerText; // Store the full text
    let words = originalText.split(' '); // Split the text into words
    let truncatedText = originalText;

    // Use a temporary span to measure text height without altering the DOM repeatedly
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.whiteSpace = 'pre-wrap';
    tempSpan.style.lineHeight = window.getComputedStyle(p).lineHeight;
    tempSpan.style.position = 'absolute';
    tempSpan.style.maxWidth = window.getComputedStyle(p).width;
    document.body.appendChild(tempSpan);

    while (words.length > 0) {
      truncatedText = words.join(' ') + '...'; // Append ellipsis
      tempSpan.innerText = truncatedText;

      if (tempSpan.scrollHeight <= maxHeight) {
        break; // Stop when the text fits within the height
      }

      words.pop(); // Remove the last word
    }

    document.body.removeChild(tempSpan); // Clean up the temporary element
    return truncatedText;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  showDialog() {
    // Open the dialog to show the gallery when the user clicks the "View" button or image
    this.displayBasic = true;
  }
  goBackToSearch() {
    // this.DynamicSearchComponent.filterForm_dynamic.reset();
    // Navigate back to the search page or route

    this.commanService.isTableSimple.next(false);
    this.commanService.isTableDynamic.next(false);
    this.commanService.isTableAdvance.next(false);
    this.commanService.currentPage.next(1);
    this.commanService.currentRow.next(15);
    this.commanService.currentData.next({});
    this.commanService.currentPrivilege.next({});
    this.router.navigate(['/']).then(() => {
      window.scrollTo(0, 0);
    });
  }
  // Method to hide the dialog (will be done automatically by PrimeNG)
  hideDialog() {
    this.displayBasic = false;
  }
  copyToClipboardFormattedDate(value: any): void {
    const formattedDate = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format the date
    if (formattedDate) {
      this.copyToClipboard(formattedDate); // Call your existing copy function
    }
  }
  copyToClipboard(value: string): void {
    // Use the Clipboard API to copy the text
    navigator.clipboard
      .writeText(value)
      .then(() => {
        // Show the success toast notification using PrimeNG's MessageService
        this.messageService.add({
          severity: 'success',
          summary: 'Copied to Clipboard',
          detail: value,
        });
      })
      .catch((err) => {
        // Show an error notification if clipboard operation fails
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to Copy',
          detail: 'There was an error copying the text.',
        });
      });
  }
  largescreen(
    gbrn: string,
    targetRoute: string,
    activeIngredient: string
  ): void {
    // Filter the data based on selected GBRN
    const selectedData = this.data.filter((item: any) => item.gbrn === gbrn);

    // Filter the data based on selected ACTIVE_INGREDIENT
    const selectedActiveIngredientData = this.data.filter(
      (item: any) => item.activeIngredient === activeIngredient
    );

    this.commanService.currentgbrn.next(gbrn);
    this.commanService.current_Active_Ingredient.next(activeIngredient);

    window.scrollTo(0, 0);

    const productInfoPayload = {
      data: selectedData,
      allData: this.data,
      totalRecords: selectedData,
      oldRecords: this.totalRecords,
      userid: this.userid,
      gbrn,
      activeIngredient, // Add selected active ingredient to the payload
      gbrnArray: this.gbrnArray,
      inchiKeyArray: this.inchiKeyArray,
      privilege_json: this.privilege_json,
      currentFilterCondition: this.currentFilterCondition,
      application_query: this.application_query,
      search_filters: this.search_filters,
      cols: this.cols,
      columns: this.columns,
      searchQueryGrid: this.searchQueryGrid,
      activeIngredientArray: this.activeIngredientArray, // Make sure activeIngredientArray is included in the payload
    };

    this.commanService.productInformationData.next(productInfoPayload);

    this.router.navigate([targetRoute]);
  }

  showToast() {
    this.messageService.add({
      severity: 'info ',
      summary: 'Coming Soon',
      detail: 'This feature is coming soon!',
    });
  }
  onImageError(event: any) {
    // Replace the broken image with the text "inventorLogo"
    const textNode = document.createElement('span');
    textNode.style.width = '300px';
    textNode.style.textAlign = 'center';

    // Replace the image with the text "inventorLogo"
    event.target.replaceWith(textNode);
  }

  onFileChange(event: any): void {
    if (event.target.files && event.target.files[0]) {
      this.fileToUpload = event.target.files[0];
    }
  }

  showRaiseQuery() {
    // Clear form controls
    this.form_RaiseQuery.controls['txtResponseEmail'].setValue('');

    this.form_RaiseQuery.controls['txtQuery'].setValue('');

    this.isShowRaiseQuery = true;

    // Fetch the modal element
    const modalElement = document.getElementById('raise_query_modal');

    if (modalElement) {
      // Initialize and display the modal
      const modalInstance = new bootstrap.Modal(modalElement);

      if (modalInstance) {
        modalInstance.show();
      } else {
        console.error('Failed to initialize modal instance.');
      }
    } else {
      console.error('Modal element not found!');
    }
  }
  // Raise Query old way
  // submitRaiseQueryForm() {
  //   // Prepare email data
  //   let emailPostData = {
  //     to: 'support@chemrobotics.com',
  //     subject: 'ChemRobotics - Discovery-suite-beta - User Query',
  //     html: `
  //           <div style="background-color: #ffc702; heigth:30px; text-align: center;">
  //           <img src="cid:logoImg" alt="Logo">
  //           </div>
  //           <div style="background-color: #eee;">
  //           <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
  //           <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
  //           <p>Search Query:</p>
  //           </div>
  //           <p>${this.searchQueryGrid}</p>
  //           <div style="background-color: #eee;">
  //           <p>Thank You!</p>
  //           <p>Team ChemRobotics</p>
  //           <p><img src="cid:logoImg" alt="Logo"></p>
  //           <p><strong>✉️ support@chemrobotics.com</strong></p>
  //           <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
  //           </div>
  //           <hr>
  //           <div style="background-color: #eee; text-align: center;">
  //           <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
  //           <div/>`,
  //   };

  //   // Prepare user query data
  //   let postdata = {
  //     mode: 'ADD_USER_QUERY',
  //     userid: this.user_data,
  //     usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
  //     searchquery: this.search_filters,
  //   };

  //   // Log post data for debugging

  //   // Send user query data
  //   this.datasearch.userMasterManage(postdata).subscribe(
  //     (res) => {
  //       // Log success respons
  //     },
  //     (err) => {
  //       // Log error response
  //     }
  //   );

  //   // Send email data
  //   this.datasearch.sendMail(emailPostData).subscribe(
  //     (res) => {
  //       // Log success response

  //       // Update UI after success
  //       this.isShowRaiseQuery = false;
  //       this.submittedquerybox();

  //       // Log UI update;
  //     },
  //     (err) => {
  //       // Log error response
  //       console.error('Error sending email:', err);
  //     }
  //   );
  // }
  // Raise Query new way
  submitRaiseQueryForm() {
    let emailPostData = new FormData();
    emailPostData.append('to', 'support@chemrobotics.com');
    emailPostData.append('cc', 'greenbookcorp@gmail.com');
    emailPostData.append('cc', 'chemroboticsros@gmail.com');
    emailPostData.append('subject', 'ChemRobotics - Agropat Discovery Suite - User Query');
    emailPostData.append(
      'subject',
      'ChemRobotics - Agropat Discovery Suite - User Query'
    );
    emailPostData.append(
      'html',
      `
          <div style="background-color: #ffc702; heigth:30px; text-align: center;">
            <img src="cid:logoImg" alt="Logo">
          </div>
          <div style="background-color: #eee;">
           <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
           <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
           <p>Search Query:</p>
          </div>
          <p>${this.searchQueryGrid}</p>
          <div style="background-color: #eee;">
           <p>Thank You!</p>
           <p>Team ChemRobotics</p>
           <p><img src="cid:logoImg" alt="Logo"></p>
           <p><strong>✉️ support@chemrobotics.com</strong></p>
           <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
          </div>
          <hr>
          <div style="background-color: #eee; text-align: center;">
           <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
          <div/>`
    );

    if (this.selectedFile) {
      emailPostData.append('file', this.selectedFile);
    }
    // debugger
    let postdata = {
      mode: 'ADD_USER_QUERY',
      userid: this.userid,
      usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
      searchquery: this.search_filters,
    };

    this.datasearch.userMasterManage(postdata).subscribe((res) => {});
    this.busyService.busy();
    this.datasearch.sendMailNew(emailPostData).subscribe(
      (res) => {
        this.busyService.idle();
        this.isShowRaiseQuery = false;
        this.form_RaiseQuery.reset({
          txtResponseEmail: '',
          txtQuery: '',
        });
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        this.submittedquerybox();
        this.messageService.add({
          severity: 'success',
          detail: 'Query raised successfully!',
        });
      },
      (error) => {
        this.busyService.idle();
        console.log('Error on Raise Query : ', error);
      }
    );
  }
  submittedquerybox() {
    const alertModalElement = document.getElementById('Querysubmitalert');
    if (alertModalElement) {
      $('#Querysubmitalert').modal('show');
      setTimeout(() => {
        $('#Querysubmitalert').modal('hide');
      }, 5000); // Close the alert modal after 5 seconds
    }
  }
  transformNewLines(text: string) {
    return text ? text.replace(/\n/g, '<br>') : '';
  }

  receiveSidebarEvent(event: boolean) {
    this.toggle_sidebar = event;
    this.changeDetectorRef.detectChanges();
  }

  receiveHeading(event: string) {
    this.heading = event;
    this.changeDetectorRef.detectChanges();
  }
  ImageFullView(item: any): void {
    this.fullImageUrl =
      'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
      item.chemicalStructure;
    const modal = new bootstrap.Modal(document.getElementById('imageModal')!);
    modal.show();
  }
  viewChemicalStructure(chemicalStructure: string): void {
    const url = `https://www.chemrobotics.com/agropat/images/chemical_structure/${chemicalStructure}`;
    window.open(url, '_blank');
  }
  navigateToWebsite(buttonType: string, productIndex: number): void {
    const accessKey = 'MTA5Ng%3D%3D';

    // Validate the arrays and product index
    if (
      this.gbrnArray &&
      this.gbrnArray[productIndex] &&
      this.inchiKeyArray &&
      this.inchiKeyArray[productIndex]
    ) {
      const gbrn = encodeURIComponent(this.gbrnArray[productIndex]);
      const inchiKey = encodeURIComponent(this.inchiKeyArray[productIndex]);

      let url = '';

      // Form the URL based on buttonType
      switch (buttonType) {
        case 'gasp':
          url = `https://www.chemrobotics.com/agro-suite/global-agro-product-directory?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'ibd':
          url = `https://www.chemrobotics.com/agropat-ultimate/ipd-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'mrl':
          url = `https://www.chemrobotics.com/agropat-ultimate/mrl-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'wipo':
          url = `https://patentscope.wipo.int/search/en/result.jsf?access_key=${accessKey}&inchikey=${inchiKey}`;
          break;
        default:
          alert('Invalid Button Type');
          return;
      }

      console.log('Generated URL:', url); // Log the generated URL
      window.open(url, '_blank'); // Open the URL in a new tab
    } else {
      console.error('GBRN or INCHIKEY is missing or invalid!');
      alert('GBRN or INCHIKEY is missing or invalid!');
    }
  }
  // Raise Query file upload veriables
  @ViewChild('fileInput') fileInput!: ElementRef;
  selectedFile: File | null = null;
  maxFileSizeMB = 10;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (file.size > this.maxFileSizeMB * 1024 * 1024) {
        alert('File is too large. Please select a file under 10 MB.');
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
    }
  }

  // Pagination
  first: any = 0;
  rows: any = 15;

  onPageChange(event: any) {
    // debugger;
    this.first = event.first;
    this.rows = event.rows;

    // Update the selected page (event.page is zero-indexed, so we add 1 to match the page number)
    this.selectedPage = event.page + 1;

    if (event.page + 1) {
      let val = event.page + 1;
      this.commanService.currentPage.next(val);
    }

    if (event.rows) {
      this.commanService.currentRow.next(this.rows);
    }
  }
  getUserAccountType(userId: string) {
    this.datasearch.getUserAccountType(userId).subscribe({
      next: (res: any) => {
        this.accountType = res.account_type || '';
      },
      error: (err) => {
        console.error('Error while fetching account type:', err); // On error
      },
    });
  }
  displayMap: { [key: string]: boolean } = {};
  getcolumnsdiscovery() {
    console.log("get column discovery called()");
    
    this.datasearch.getdropdown().subscribe(
      (res: any) => {
        // ✅ Extract columns array safely for new API format
        const columnsArray = Array.isArray(res?.data?.results)
          ? res.data.results
          : Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
          ? res
          : null;

        if (!columnsArray) {
          console.error('🚫 Invalid dropdown response structure:', res);
          return;
        }

        this.columns = columnsArray;
        console.log("444444444444",res);
        
        this.displayMap = {};

        for (const col of columnsArray) {
          // ✅ Use 'field' as column name (since new API uses 'field', not 'tableColumnName')
          const colName = col?.field ?? 'UNKNOWN';
          // console.log("column name : ", colName)
          const isDisplayed = Number(col?.isDisplay) === 1;
          this.displayMap[colName] = isDisplayed;
        }
      },
      (error) => {
        console.error('❌ Error fetching dropdown data:', error);
      }
    );
  }

  getImageUrl(filename: string): string {
    if (!filename) return '';
    return (
      'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
      encodeURIComponent(filename)
    );
  }
}
